function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 110 16A8 8 0 018 0zm1 2L4 9.5 8 9l-1 5 5-7.5L8 7l1-5z",
    fill: "#212A33",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/badges/ic-badge-lightning.svg";